export enum OrbitFundProjectStep {
  CONNECTING_WALLET,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  FUNDED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
